<template>
<div id="home">
    <vue-scroll-progress-bar id="scroll-bar" height="5px" backgroundColor="#e76f51"/>
    <!--
    <div class="page_mover">
      <div @click="move_page_up">⬆️</div>
      <div @click="move_page_down">⬇️</div>
    </div>
    -->
    <vue-scroll-snap>
      <Info/>      
      <Timeline/>
      <Hobbies/>
    </vue-scroll-snap>
  </div>
    
</template>

<script>
import Info from './Info.vue'
import Hobbies from './Hobbies.vue'
import Timeline from './Timeline.vue'
import {VueScrollProgressBar} from '@guillaumebriday/vue-scroll-progress-bar'
import VueScrollSnap from "vue-scroll-snap";


export default {
  name: 'Home',
  components: {
    Info,
    Hobbies,
    Timeline,
    VueScrollProgressBar,
    VueScrollSnap
  },
  beforeCreate: function() {
      document.body.style.background = "#264653";
  },
  data() {
    return {
      page: 0,
    };
  },
  methods: {
    move_page_up: function () {
      if (this.page === 1){
        window.location.href = '/#informations';
        this.page = 0;
        return;
      }
      if (this.page === 2){
        window.location.href = '/#hobby';
        this.page = 1
        return;
      }
    },
    move_page_down: function () {
      if (this.page === 0) {
        window.location.href = '/#hobby';
        this.page = 1
        return;
      }
      if (this.page === 1){
        window.location.href = '/#timeline';
        this.page = 2;
        return;
      }
    }
  },
}
</script>

<style>


*::-webkit-scrollbar{
  display: none;
  scrollbar-width: none;  
}
#home {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
}
h1{
  font-size: 10vh;
  font-weight: 900;
}
h2{
  font-size: 3vh;
  font-weight: 300;
}
p{
  font-weight: 300;
}
/*
.page_mover{
  visibility: hidden;
  position: fixed;
  bottom: 100px;
}
*/

@media (min-width: 320px) and (max-width: 850px) {
  /* 
  .scroll-snap-container {
    height: 100vh;
    scroll-snap-type: y mandatory;    
  }
  add scroll-snap-align: on elements */
  
}

</style>